/**
 * This function monitors changes to radio buttons within the specified elements and logs the selected value to the console.
 */
export default () => {
    // Find the form and session elements
    const form = document.querySelector('.gform_wrapper');
    const sessions = document.querySelectorAll('.event-program__session');

    // Check if required elements are found
    if (form === null || sessions === null) {
        return;
    }

    // Observe changes to the radio buttons and update the corresponding select element
    observeProgramSessions()
    observeGravityFormsDropdowns()

    function observeProgramSessions() {
        // Loop through the session elements
        sessions.forEach((session) => {
            // Find all radio button elements within the session
            const speakers = session.querySelectorAll('.event-program__session-radio');

            speakers.forEach((speaker) => {
                // Add a change event listener to each radio button
                speaker.addEventListener('change', () => {
                    // Cast the speaker element to HTMLInputElement to access the checked property
                    const radioSpeaker = speaker as HTMLInputElement;

                    // Check if the radio button is checked
                    if (radioSpeaker.checked) {
                        const selectedValue = radioSpeaker.value;
                        const selectedName = radioSpeaker.name;
                        const targetClass = '.' + selectedName;

                        // Find the select element by ID 'input_1_10'
                        const selectElement = document.querySelector(targetClass + ' select') as HTMLSelectElement;

                        if (selectElement === null) {
                            return;
                        }

                        // Loop through the options to find the one with the value "Jeroen Maes"
                        for (let i = 0; i < selectElement.options.length; i++) {
                            if (selectElement.options[i].value === selectedValue) {
                                // Set the 'selected' attribute for the option to make it the selected option
                                selectElement.options[i].selected = true;
                                break; // No need to continue the loop once we've found the option
                            }
                        }
                    }
                });
            });
        });
    }

    function observeGravityFormsDropdowns() {
        // Loop through Gravity Forms fields
        const sessionOptions = form.querySelectorAll('.populate-session');

        if (sessionOptions === null) {
            return;
        }

        sessionOptions.forEach((dropdown) => {
            const dropdownElement = dropdown.querySelector('select') as HTMLSelectElement;
            dropdownElement.addEventListener('change', () => {
                const targetValue = dropdownElement.value;
                const targetClassList = dropdown.classList
                let targetClass = null;

                for (let i = 0; i < targetClassList.length; i++) {
                    const className = targetClassList[i];
                    if (className.startsWith("session_")) {
                        targetClass = className;
                        break; // If you want to stop after finding the first match, you can break here.
                    }
                }

                selectProgramSpeaker(targetClass, targetValue)
            })
        })
    }

    function selectProgramSpeaker(targetClass: string, targetValue: string) {
        // Assuming you have a reference to the container element that holds these radio inputs
        const currentSession = document.querySelector(".event-program__" + targetClass) as HTMLElement;

        // Find all radio inputs within the container element
        const radioInputs = currentSession.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;

        // Loop through the radio inputs and find the one with the value "targetValue"
        for (const radioInput of radioInputs) {

            // Clear all radio buttons if the target value is empty
            if (targetValue === "") {
                radioInput.checked = false;
            }

            if (radioInput.value === targetValue) {
                radioInput.checked = true;
                break;
            }
        }
    }

};